import type { DemographicConfiguration } from "../../../types/demographic.types";

export const AHT_SENSITIVE_ATTRIBUTE_CONSENT_BASIS = "healthcare_provision_art9_2h";

export const AHT_BIOLOGICAL_SEX_PURPOSE =
  "AHT weight management — IOTF cut-off lookup for adolescent eligibility and clinical decision-making";

export const AHT_ETHNIC_ADJUSTMENT_PURPOSE =
  "AHT weight management — ethnic-adjustment BMI threshold application for adult eligibility";

export const ahtDemographicConfiguration: DemographicConfiguration = {
  bannerFields: [
    { field: "dateOfBirth", label: "Date of birth", type: "date" },
    { field: "ageYears", label: "Age (years)", type: "number" },
    {
      field: "biologicalSex",
      label: "Biological sex",
      type: "sensitive_attribute",
      selectOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other / prefer not to say" },
      ],
      helpText: "Required for IOTF adolescent BMI cut-off lookup",
      sensitiveAttribute: {
        consentBasis: AHT_SENSITIVE_ATTRIBUTE_CONSENT_BASIS,
        purposeOfProcessing: AHT_BIOLOGICAL_SEX_PURPOSE,
      },
    },
    {
      field: "ethnicAdjustmentGroup",
      label: "Ethnicity",
      type: "sensitive_attribute",
      selectOptions: [
        { value: "White - British", label: "White - British" },
        { value: "White - Irish", label: "White - Irish" },
        { value: "White - Any other White background", label: "White - Any other White background" },
        { value: "Mixed - White and Black Caribbean", label: "Mixed - White and Black Caribbean" },
        { value: "Mixed - White and Black African", label: "Mixed - White and Black African" },
        { value: "Mixed - White and Asian", label: "Mixed - White and Asian" },
        { value: "Mixed - Any other mixed background", label: "Mixed - Any other mixed background" },
        { value: "Asian or Asian British - Indian", label: "Asian or Asian British - Indian" },
        { value: "Asian or Asian British - Pakistani", label: "Asian or Asian British - Pakistani" },
        { value: "Asian or Asian British - Bangladeshi", label: "Asian or Asian British - Bangladeshi" },
        { value: "Asian or Asian British - Any other Asian background", label: "Asian or Asian British - Any other Asian background" },
        { value: "Black or Black British - Caribbean", label: "Black or Black British - Caribbean" },
        { value: "Black or Black British - African", label: "Black or Black British - African" },
        { value: "Black or Black British - Any other Black background", label: "Black or Black British - Any other Black background" },
        { value: "Other Ethnic Groups - Chinese", label: "Other Ethnic Groups - Chinese" },
        { value: "Any other ethnic group", label: "Any other ethnic group" },
        { value: "Not Stated", label: "Not Stated" },
      ],
      helpText:
        "Used to apply ethnic-adjustment BMI thresholds for adult eligibility",
      sensitiveAttribute: {
        consentBasis: AHT_SENSITIVE_ATTRIBUTE_CONSENT_BASIS,
        purposeOfProcessing: AHT_ETHNIC_ADJUSTMENT_PURPOSE,
      },
    },
  ],
};
